import ATE from "../../../ActionTypeEnum";
import IJobInfo from "../interfaces/IJobInfo";
import IJobBtcResult from "../interfaces/IJobBtcResult";

export default {

    infoRequest: (clear: boolean) => ({
        type: ATE.JOB_INFO_REQUEST,
        value: clear,
    }),
    infoNonExist: () => ({
        type: ATE.JOB_INFO_NON_EXIST,
    }),
    infoFailure: () => ({
        type: ATE.JOB_INFO_FAILURE,
    }),
    infoSuccess: (data: IJobInfo) => ({
        type: ATE.JOB_INFO_SUCCESS,
        value: data,
    }),
    getInputRequest: () => ({
        type: ATE.JOB_GET_INPUT_REQUEST,
    }),
    getInputFailure: () => ({
        type: ATE.JOB_GET_INPUT_FAILURE,
    }),
    getInputSuccess: () => ({
        type: ATE.JOB_GET_INPUT_SUCCESS,
    }),

    rerunRequest: () => ({
        type: ATE.JOB_RERUN_REQUEST,
    }),
    rerunFailure: () => ({
        type: ATE.JOB_RERUN_FAILURE,
    }),
    rerunSuccess: () => ({
        type: ATE.JOB_RERUN_SUCCESS,
    })
};
